import ExecAPI from 'appRoot/api/api';

/**
 * Sets the primary email address for the user.
 * @param {String} email new email address
 * @returns {Promise} Promise that delivers the user's email address and array of additional email addresses as stored on the server.
 */
export function SetPrimaryEmail(email)
{
	return ExecAPI("UserManageData/SetPrimaryEmail", { email });
}
/**
 * Sends a test message to the given email address, only if it is one of the user's configured email addresses.
 * @param {String} email email address
 * @returns {Promise} Promise
 */
export function TestEmail(email)
{
	return ExecAPI("UserManageData/TestEmail", { email });
}
/**
 * Returns an object containing user data, including the array of additional email addresses which the user has configured.
 * @returns {Promise} Promise that delivers the user's data.
 */
export function GetUserData()
{
	return ExecAPI("UserManageData/GetUserData");
}
/**
 * Sets the list of additional email addresses which the user has configured.
 * @param {Array} additionalEmails Array of email address strings.
 * @returns {Promise} Promise that delivers the user's email address and array of additional email addresses as stored on the server.
 */
export function SetAdditionalEmails(additionalEmails)
{
	return ExecAPI("UserManageData/SetAdditionalEmails", { additionalEmails });
}
/**
 * Deletes the passkey with the specified Base64Url-encoded id from the user who is logged in with the current session.
 * @param {String} id Base64URL-encoded Passkey Id.
 * @returns {Promise} Promise that resolves when the deletion is complete.
 */
export function DeletePasskey(id)
{
	return ExecAPI("UserManageData/DeletePasskey", { id });
}
/**
 * Renames the passkey with the specified Base64Url-encoded id of the user who is logged in with the current session.
 * @param {String} id Base64URL-encoded Passkey Id.
 * @param {String} name New name.  An empty string leaves the passkey unnamed.
 * @returns {Promise} Promise that delivers the user's data, like GetUserData.
 */
export function RenamePasskey(id, name)
{
	return ExecAPI("UserManageData/RenamePasskey", { id, name });
}
/**
 * Labels and descriptions of the permission names an MCP API token can grant (server: CodeReviewAccess), in display order.
 */
export const ApiTokenPermissionInfo = {
	CodeReviewRead: { label: "Code Review: read", description: "View findings, reviewed pushes, fix batches and reports." },
	CodeReviewWrite: { label: "Code Review: write", description: "Act on findings: edit, comment, reject, mark fixed, reopen, change severity, request re-evaluation, accept or decline suggestions.  Closing a high or critical finding waits for your confirmation in the web UI." },
	CodeReviewApproveFixes: { label: "Code Review: approve fixes", description: "Approve findings for fixes and run or discard fix batches.  Pushing a fix batch always stays in the web UI." },
	CodeReviewAdmin: { label: "Code Review: admin views", description: "Administrator-only Code Review views, such as raw run output.  Does not include the write or approve-fixes permissions." }
};
/**
 * Lists the current user's MCP API tokens (never their values) and the permissions a new token may grant.
 * @returns {Promise} Promise that delivers { tokens, grantablePermissions, maxNameLength }.
 */
export function GetApiTokens()
{
	return ExecAPI("UserManageData/GetApiTokens");
}
/**
 * Creates an MCP API token for the current user.
 * @param {String} name Token name, unique among the user's tokens.
 * @param {Array} permissions Permission names to grant (each must be one the user currently has).
 * @returns {Promise} Promise that delivers { token, created, tokens, grantablePermissions, maxNameLength }.  The token value is shown once and cannot be retrieved later.
 */
export function CreateApiToken(name, permissions)
{
	return ExecAPI("UserManageData/CreateApiToken", { name, permissions });
}
/**
 * Revokes one of the current user's MCP API tokens.
 * @param {Number} id Token ID.
 * @returns {Promise} Promise that delivers the remaining tokens, like GetApiTokens.
 */
export function RevokeApiToken(id)
{
	return ExecAPI("UserManageData/RevokeApiToken", { id });
}